import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5534_9752)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 12.5C24 5.87259 18.6274 0.5 12 0.5C5.37259 0.5 -2.89694e-07 5.87259 0 12.5C2.89694e-07 19.1274 5.37259 24.5 12 24.5C18.6274 24.5 24 19.1274 24 12.5ZM13.7127 21.481C13.7127 22.2951 13.0446 22.9568 12.0962 22.9758C12.0699 22.976 12.0436 22.9761 12.0173 22.9762H11.9827C6.20482 22.9669 1.52381 18.2801 1.52381 12.5C1.52381 6.71418 6.21415 2.02383 12 2.02383C12.0312 2.02383 12.0624 2.02396 12.0935 2.02424C13.1637 2.0433 13.7127 2.70499 13.7127 3.51901C13.7127 4.34751 12.9804 4.95714 12.2045 4.95714C11.4286 4.95716 11.3905 4.95716 10.6478 5.01666C9.90506 5.07618 9.13706 5.68582 9.13706 6.51186C9.13706 7.34281 9.81206 8.01195 10.6478 8.01195H17.2346C18.0679 8.01195 18.7429 8.68112 18.7429 9.50715C18.7429 10.3332 18.0679 11.0024 17.2346 11.0024H7.08914C6.25344 11.0024 5.57844 11.674 5.57844 12.5024C5.57844 13.3285 6.25344 13.9976 7.08914 13.9976H12.2045C13.0377 13.9976 13.7127 14.6668 13.7127 15.4953C13.7127 16.3213 13.0377 16.9905 12.2045 16.9905H10.6478C9.81206 16.9905 9.13706 17.6597 9.13706 18.4857C9.13706 19.3142 9.82886 19.9189 10.6478 19.9809C10.7123 19.9858 10.7713 19.9903 10.8257 19.9944C11.1139 20.0164 11.2714 20.0284 11.4291 20.035C11.619 20.0429 11.8092 20.0429 12.2286 20.0429C13.0618 20.0429 13.7127 20.655 13.7127 21.481Z"
        fill="#11181C"
      />
    </g>
    <defs>
      <clipPath id="clip0_5534_9752">
        <rect y="0.5" width="24" height="24" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
